// src/project/data/fetches/riderProducts.js
import { buildUrlWithAuth, RIDER_ENDPOINTS } from '../config/apiConfig'

export default {
  url() {
    // V3 : /product/list?group=ultraxeno&target=rider — Filtre uniquement les produits pour livreurs
    return buildUrlWithAuth(RIDER_ENDPOINTS.PRODUCT_LIST, { target: 'rider' })
  },
  parse(raw = {}) {
    // Réponse V3 attendue :
    // { statusCode: 200, message: "Found", count: N, data: [ { id, name, description, price, currency, stock, isActive, ... } ] }
    if (raw?.statusCode !== 200) {
      return {
        statusCode: raw?.statusCode || 500,
        message: raw?.message || 'Erreur lors de la récupération des produits',
        data: [],
      }
    }
    // L'API retourne un tableau directement dans data
    const items = Array.isArray(raw?.data) ? raw.data : raw?.data?.data || []
    return {
      statusCode: 200,
      message: 'Ok',
      data: items.filter(item => item.isActive !== false), // Exclure les produits inactifs
    }
  },
}
